import { Injectable } from '@angular/core';
import { CLIENTS_JOBS_ROUTE } from '../../client-data/client-data.data';
import { NEW_ENTITY_ROUTE } from '../../entity-data/entity-data.data';
import { CLIENTS_MASTER_ROUTE } from '../../main/main.data';

@Injectable({
  providedIn: 'root',
})
export class ClientsService {
  constructor() {}

  buildNewJobRoutePath(clientId: string): string[] {
    return [...this.buildJobListRoute(clientId), NEW_ENTITY_ROUTE];
  }

  buildJobDetailRoutePath(clientId: string, jobId: string): string[] {
    return [...this.buildJobListRoute(clientId), jobId];
  }

  buildJobListRoute(clientId: string) {
    return [CLIENTS_MASTER_ROUTE, clientId, CLIENTS_JOBS_ROUTE];
  }
}
